import { Container, Row, Col } from "react-bootstrap";
import Equity from './Equity';
import MutualFunds from './MutualFunds';


const HoldingsContents = ({ holdingssActiveTabKey }) => {



    return (
        <Container fluid className='p-0'>
            <Row className='g-0'>
                <Col>
                    {
                        holdingssActiveTabKey === 'equity' &&
                        <Equity />

                    }
                    {
                        holdingssActiveTabKey === 'mutual_funds' &&
                        <MutualFunds />
                    }

                </Col>
            </Row>
        </Container>

    );
};

export default HoldingsContents;